<template>
  <div class="spinner" :class="{ 'spinner--fullscreen': fullscreen }">
    <div class="spinner__container">
      <div class="spinner__header">
        <slot name="header">
          <div v-html="headerText"></div>
        </slot>
      </div>
      <span class="spinner-grow" role="status" aria-hidden="true"></span>
      <span class="sr-only">Loading...</span>
      <div class="spinner__text">
        <slot>
          <div v-html="bodyText"></div>
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
import {
  addClassModalOpenOnBody,
  removeClassModalOpenFromBody
} from '../../utils/BOM';
import { SPINNER_TYPE } from '../../constants/common';

export default {
  props: ['fullscreen', 'type'],
  data() {
    return {
      headerText: '',
      bodyText: ''
    };
  },
  watch: {
    type: {
      immediate: true,

      handler(val) {
        this.bodyText = `We are sending your request.<br />This may take a few seconds.`;

        switch (val) {
          case SPINNER_TYPE.FETCHING_ALERT:
            this.headerText = 'Fetching alert data';
            this.bodyText = `We are loading your data.<br />This may take a few seconds.`;
            break;

          case SPINNER_TYPE.CREATING_ALERT:
            this.headerText = 'Creating alert';
            break;

          case SPINNER_TYPE.DELETING_ALERT:
            this.headerText = 'Deleting alert';
            break;

          case SPINNER_TYPE.DELETING_ALERT:
            this.headerText = 'Deleting alert';
            break;

          case SPINNER_TYPE.EDITING_ALERT:
            this.headerText = 'Editing alert';
            break;

          case SPINNER_TYPE.SNOOZING_ALERT:
            this.headerText = 'Snoozing alert';
            break;

          case SPINNER_TYPE.UN_SNOOZING_ALERT:
            this.headerText = 'Un-Snoozing alert';
            break;

          default:
            this.headerText = '';
            this.bodyText = '';
            break;
        }
      }
    }
  },
  mounted() {
    // Prevent background page from scrolling when the modal is open.
    addClassModalOpenOnBody();
  },
  beforeDestroy() {
    // Allow background page to scroll when the modal is closed.
    removeClassModalOpenFromBody();
  }
};
</script>

<style lang="scss">
.spinner {
  color: $apnic-blue;
  display: inline-block;

  &__container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  &__header {
    font-weight: bold;
    color: black;
    text-align: center;
    margin-bottom: 8px;
  }

  &__text {
    margin-top: 8px;
    padding: 0 1rem;
    text-align: center;
    line-height: 18px;
  }

  &--fullscreen {
    z-index: 9999;
    position: fixed;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba($color: #000000, $alpha: 0.7);

    .spinner {
      &-grow {
        width: 80px;
        height: 80px;
      }

      &__container {
        background: white;
        padding: 24px;
        margin: 16px;
      }
    }
  }
}
</style>
